import { Record, Union } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { DrawerControl__Close_52723E41, DrawerControl_$ctor_662CADE, ProductModel, Drawer_$reflection } from "../Shared.js";
import { record_type, option_type, union_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { createElement } from "react";
import React from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "../../../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { $007CUserCanAccess$007C_$007C, Feat, User__CanAccess_Z21948E14 } from "../../../Shopfoo.Domain.Types/Security.js";
import { Page_CurrentNotFound, Router_navigatePage } from "../../../Routing.js";
import { Toast } from "../../Shared.js";
import { createObj } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { ofArray } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { CatalogInfoForm } from "./CatalogInfo.js";
import { ActionsForm } from "./Actions.js";
import { AdjustStockForm } from "./AdjustStock.js";
import { ReceiveSupplyForm } from "./ReceiveSupply.js";
import { InputSalesForm } from "./InputSales.js";
import { unwrap } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { ManagePriceForm } from "./ManagePrice.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CloseDrawer", "OpenDrawer"];
    }
}

function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Details.Page.Msg", [], Msg, () => [[], [["Item", Drawer_$reflection()]]]);
}

class Model extends Record {
    constructor(Drawer) {
        super();
        this.Drawer = Drawer;
    }
}

function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Details.Page.Model", [], Model, () => [["Drawer", option_type(Drawer_$reflection())]]);
}

function init() {
    return [new Model(undefined), Cmd_none()];
}

function update(msg, model) {
    if (msg.tag === 1) {
        return [new Model(msg.fields[0]), Cmd_none()];
    }
    else {
        return [new Model(undefined), Cmd_none()];
    }
}

export function ProductDetailsView(productDetailsViewInputProps) {
    let elems_5, elems_4, elems_3;
    const sku = productDetailsViewInputProps.sku;
    const env = productDetailsViewInputProps.env;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    let patternInput_1;
    const initial = new ProductModel(sku, false);
    patternInput_1 = reactApi.useState(initial);
    const updateProductModel = patternInput_1[1];
    const productModel = patternInput_1[0];
    let fullContext;
    let copyOfStruct = env;
    fullContext = copyOfStruct.FullContext;
    useEffectOnce(() => {
        if (!User__CanAccess_Z21948E14(fullContext.User, new Feat(2, []))) {
            Router_navigatePage(Page_CurrentNotFound());
        }
    });
    const drawerControl = DrawerControl_$ctor_662CADE((drawer) => {
        dispatch(new Msg(1, [drawer]));
    }, () => {
        dispatch(new Msg(0, []));
    });
    let hasActions;
    const matchValue = fullContext.User;
    const matchValue_1 = sku.Type;
    let matchResult;
    if ($007CUserCanAccess$007C_$007C(new Feat(3, []), matchValue) != null) {
        switch (matchValue_1.tag) {
            case 0: {
                matchResult = 0;
                break;
            }
            case 1: {
                if ($007CUserCanAccess$007C_$007C(new Feat(3, []), matchValue) != null) {
                    matchResult = 0;
                }
                else if ($007CUserCanAccess$007C_$007C(new Feat(4, []), matchValue) != null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            default:
                matchResult = 1;
        }
    }
    else if ($007CUserCanAccess$007C_$007C(new Feat(4, []), matchValue) != null) {
        switch (matchValue_1.tag) {
            case 0: {
                matchResult = 0;
                break;
            }
            case 1: {
                if ($007CUserCanAccess$007C_$007C(new Feat(3, []), matchValue) != null) {
                    matchResult = 0;
                }
                else if ($007CUserCanAccess$007C_$007C(new Feat(4, []), matchValue) != null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            default:
                matchResult = 1;
        }
    }
    else if ($007CUserCanAccess$007C_$007C(new Feat(3, []), matchValue) != null) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else if ($007CUserCanAccess$007C_$007C(new Feat(4, []), matchValue) != null) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            hasActions = true;
            break;
        }
        default:
            hasActions = false;
    }
    const isDrawerOpen = model_1.Drawer != null;
    const onSavePrice = (tupledArg) => {
        let copyOfStruct_1 = env;
        copyOfStruct_1.ShowToast(new Toast(1, [tupledArg[0], tupledArg[1]]));
    };
    return createElement("div", createObj(Helpers_combineClasses("drawer", ofArray([["key", `${"product-details"}-drawer`], ["className", "drawer-end"], (elems_5 = [createElement("input", createObj(Helpers_combineClasses("drawer-toggle", ofArray([["type", "checkbox"], ["key", `${"product-details"}-drawer-toggle`], ["id", `${"product-details"}-drawer-toggle`], ["checked", isDrawerOpen], ["onChange", (ev) => {
        ev.target.checked;
    }]])))), createElement("div", createObj(Helpers_combineClasses("drawer-content", toList(delay(() => append(singleton(["key", `${"product-details"}-drawer-content`]), delay(() => append(hasActions ? singleton(["className", "grid grid-cols-4 gap-4"]) : empty(), delay(() => {
        let elems_2;
        return singleton((elems_2 = toList(delay(() => append(singleton(createElement("div", createObj(toList(delay(() => append(singleton(["key", `${"product-details"}-catalog`]), delay(() => {
            let elems;
            return append(singleton((elems = [createElement(CatalogInfoForm, {
                key: "catalog-info",
                $key: "catalog-info",
                fullContext: fullContext,
                productModel: productModel,
                fillTranslations: (arg) => {
                    let copyOfStruct_6 = env;
                    copyOfStruct_6.FillTranslations(arg);
                },
                onSaveProduct: (tupledArg_4) => {
                    const product = tupledArg_4[0];
                    updateProductModel(new ProductModel(product.SKU, productModel.SoldOut));
                    let copyOfStruct_5 = env;
                    copyOfStruct_5.ShowToast(new Toast(2, [product, tupledArg_4[1]]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])), delay(() => {
                if (hasActions) {
                    return isDrawerOpen ? singleton(["className", "col-span-2"]) : singleton(["className", "col-span-3"]);
                }
                else {
                    return empty();
                }
            }));
        }))))))), delay(() => {
            let elems_1;
            return hasActions ? singleton(createElement("div", createObj(ofArray([["key", `${"product-details"}-actions`], ["className", "col-span-1"], (elems_1 = [createElement(ActionsForm, {
                key: "actions",
                $key: "actions",
                fullContext: fullContext,
                sku: sku,
                drawerControl: drawerControl,
                onSavePrice: onSavePrice,
                setSoldOut: (soldOut) => {
                    if (soldOut !== productModel.SoldOut) {
                        updateProductModel(new ProductModel(productModel.SKU, soldOut));
                    }
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_2))]));
    }))))))))), createElement("div", createObj(Helpers_combineClasses("drawer-side", ofArray([["key", `${"product-details"}-drawer-side`], ["className", "h-full w-full z-[9999]"], (elems_4 = [createElement("label", createObj(Helpers_combineClasses("drawer-overlay", ofArray([["key", `${"product-details"}-drawer-overlay`], ["onClick", (_arg_2) => {
        DrawerControl__Close_52723E41(drawerControl);
    }]])))), createElement("div", createObj(ofArray([["key", `${"product-details"}-drawer-side-content`], ["className", "h-full w-1/4 bg-base-100 p-4"], (elems_3 = toList(delay(() => {
        let stock_1, currency, currency_1, defaultPrice, priceModel, prices;
        const matchValue_4 = model_1.Drawer;
        if (matchValue_4 != null) {
            return (matchValue_4.tag === 3) ? ((stock_1 = matchValue_4.fields[0], singleton(createElement(AdjustStockForm, {
                key: "product-details",
                $key: "product-details",
                fullContext: fullContext,
                stock: stock_1,
                drawerControl: drawerControl,
                onSave: (tupledArg_1) => {
                    let copyOfStruct_2 = env;
                    copyOfStruct_2.ShowToast(new Toast(4, [tupledArg_1[0], tupledArg_1[1]]));
                },
            })))) : ((matchValue_4.tag === 2) ? ((currency = matchValue_4.fields[0], singleton(createElement(ReceiveSupplyForm, {
                key: "product-details",
                $key: "product-details",
                sku: sku,
                currency: currency,
                fullContext: fullContext,
                drawerControl: drawerControl,
                onSave: (tupledArg_2) => {
                    let copyOfStruct_3 = env;
                    copyOfStruct_3.ShowToast(new Toast(5, [tupledArg_2[0], tupledArg_2[1]]));
                },
            })))) : ((matchValue_4.tag === 1) ? ((currency_1 = matchValue_4.fields[0], (defaultPrice = matchValue_4.fields[1], singleton(createElement(InputSalesForm, {
                key: "product-details",
                $key: "product-details",
                sku: sku,
                currency: currency_1,
                defaultPrice: unwrap(defaultPrice),
                fullContext: fullContext,
                drawerControl: drawerControl,
                onSave: (tupledArg_3) => {
                    let copyOfStruct_4 = env;
                    copyOfStruct_4.ShowToast(new Toast(3, [tupledArg_3[0], tupledArg_3[1]]));
                },
            }))))) : ((priceModel = matchValue_4.fields[0], (prices = matchValue_4.fields[1], singleton(createElement(ManagePriceForm, {
                key: "product-details",
                $key: "product-details",
                fullContext: fullContext,
                price: priceModel,
                prices: prices,
                drawerControl: drawerControl,
                onSave: onSavePrice,
            })))))));
        }
        else {
            return empty();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
}

